
import { Search } from 'lucide-react';
import { Input } from '@/components/ui/input';

interface UsersSearchProps {
  searchQuery: string;
  onSearchChange: (value: string) => void;
}

export function UsersSearch({ searchQuery, onSearchChange }: UsersSearchProps) {
  return (
    <div className="relative w-full sm:w-auto">
      <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground" />
      <Input
        placeholder="Search users..."
        className="pl-8 w-full sm:w-[240px]"
        value={searchQuery}
        onChange={(e) => onSearchChange(e.target.value)}
      />
    </div>
  );
}
